import { render } from "./Player.vue?vue&type=template&id=77e236e0&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=77e236e0&lang=scss&scoped=true"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e236e0"]])

export default __exports__